import { useHistory, useParams } from "react-router";
import { Tabs } from "antd";
import { useState } from "react";

import "../../../project-setting-menu/module-settings/module-settings.scss";
import FeatureTemplateSubscriptionSettings from "components/manage-feature-wf-templates/feature-template-subscription-settings";
import { FeatureTypes } from "entity-app/constants";

const featureTabItemLabels: Partial<Record<FeatureTypes, string>> = {
  [FeatureTypes.BID_PACKAGE]: "Bid Package Templates",
  [FeatureTypes.DESIGN_PACKAGE]: "Design Package Templates",
  [FeatureTypes.MATERIALS]: "Material Templates"
};

function FeatureSubscriptionSettings({
  featureId
}: {
  featureId: FeatureTypes;
}) {
  const history = useHistory();
  const { tab2Id, tab3Id } = useParams() as any;
  const [tabIndex, setTabIndex] = useState<string>(tab3Id || "dateblock");
  const tabItems = [
    {
      label: <span className="pl-2.5">{featureTabItemLabels[featureId]}</span>,
      key: "dateblock",
      children: <FeatureTemplateSubscriptionSettings featureId={featureId} />
    }
  ];
  return (
    <div className="w-full bg-white h-full module-settings--tabs">
      <div className="flex flex-col">
        <Tabs
          tabPlacement="start"
          tabBarGutter={2}
          tabBarStyle={{ width: "220px" }}
          activeKey={tabIndex}
          items={tabItems}
          onChange={(activeKey) => {
            history.push(`/settings/modules/${tab2Id}/${activeKey.toString()}`);
            setTabIndex(activeKey);
          }}
          data-testid="index-tabs"
        />
      </div>
    </div>
  );
}
export default FeatureSubscriptionSettings;
